import { pushToDataLayer } from '@repo/shared/shared';
import { useRouter } from 'next/router';
import { useCart } from '@/entities/cart';
import { Slide } from '@/shared/ui';
import { useCartStoreActions } from 'src/entities/cart/hooks/cartStoreHooks';
import { prepareColor } from '../lib/colorUtils';
import { prepareQuantity } from '../lib/quantityUtils';

type ProductVariant = {
  color: {
    value: string;
    label: string;
    hex: string;
  };
  images: Slide[];
};

type UseProductSubmitProps = {
  slug: string;
  name: string;
  price: number;
  variants: ProductVariant[];
  commonImages: Slide[];
  quantityDiscounts?: any[];
};

const useProductSubmit = ({
  slug,
  name,
  price,
  variants,
  commonImages,
  quantityDiscounts,
}: UseProductSubmitProps) => {
  const router = useRouter();
  const { addItem } = useCartStoreActions();
  const { onOpen } = useCart();

  const onSubmit = () => {
    const quantity = prepareQuantity(router.query.quantity);
    const selectedColor = prepareColor(router.query.color);

    let selectedImage;

    if (selectedColor) {
      const activeVariant = variants.find((variant) => variant.color.value === selectedColor);
      if (activeVariant?.images.length) {
        selectedImage = activeVariant.images[0]!.src;
      }
    }

    if (!selectedImage) {
      selectedImage = commonImages[0]?.src ?? variants[0]?.images[0]?.src;
    }

    if (!selectedImage) return;

    const slugWithColor = `${slug}-${selectedColor}`;

    addItem({
      slug: slugWithColor,
      title: name,
      price: price,
      quantity,
      imageUrl: selectedImage,
      color: selectedColor,
      quantityDiscounts,
    });

    pushToDataLayer('product-added-to-cart', {
      product: {
        name,
        slug: slugWithColor,
        price,
        quantity,
        color: selectedColor,
      },
    });

    onOpen();
  };

  return onSubmit;
};

export default useProductSubmit;
